import { Heading, Stack, StackDivider, Text } from '@chakra-ui/react';
import * as React from 'react';

import { EventTime } from '@/components/EventTime';

export const VideoHeaderPresentational: React.FC<{
  name: string;
  startDate: string;
  endDate: string;
  label: string | undefined;
}> = (props) => {
  return (
    <Stack spacing="1">
      <Heading size="lg">{props.name}</Heading>
      <Stack
        direction="row"
        alignItems="center"
        divider={<StackDivider borderColor="gray.400" />}
        textStyle="compact"
      >
        {props.label && <Text>{props.label}</Text>}
        <EventTime
          startDate={props.startDate}
          endDate={props.endDate}
          showBrowserTimezone
        />
      </Stack>
    </Stack>
  );
};
